import { makeStyles } from 'tss-react/mui';

// dialogPaper: AccountSettings (Dialog paper). Rest: ChangePasswordForm.
export default makeStyles()((theme) => {
  const forgotHintIconSize = theme.typography.pxToRem(16);

  return {
    popover: {
      pointerEvents: 'none',
    },
    popoverContent: {
      padding: theme.spacing(1),
      boxSizing: 'border-box',
      width: 'max-content',
      maxWidth: 'min(320px, calc(100vw - 48px))',
    },
    dialogPaper: {
      margin: theme.spacing(2),
      maxHeight: 'calc(100vh - 32px)',
    },
    /**
     * Inline row + vertical-align: middle — aligns to baseline + half x-height (MDN), i.e. the
     * cap/x-height band, not flex “center” (whole line box incl. descenders) nor icon-bottom-on-baseline.
     */
    forgotPasswordHint: {
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),
      color: theme.palette.primary.main,
      fontSize: theme.typography.caption.fontSize,
      lineHeight: forgotHintIconSize,
    },
    forgotPasswordHintIcon: {
      fontSize: forgotHintIconSize,
      lineHeight: forgotHintIconSize,
    },
    checkmark: {
      color: theme.palette.success?.main || theme.palette.primary.main,
    },
    dialogueContentContainer: {
      margin: 0,
      padding: 0,
      minHeight: '390px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    dialogHeaderRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingRight: theme.spacing(1),
    },
  };
});
